import { environment } from '../../../environments/environment';
import { ApiService } from './';
import { JwtService } from './jwt.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class DocumentService {
  constructor(
    private apiService: ApiService,
    private jwtService: JwtService,
    private http: HttpClient
  ) {}

  getUrl(description: string) {
    const params = {
      description: description
    };
    return this.apiService.post('sponsorship/show', params);
  }

  postSlideShareUrl(description: string, slideshare_url: string) {
    const params = {
      description: description,
      slideshare_url: slideshare_url
    };
    return this.apiService.post('sponsorship/saveUrl', params);
  }

  upload(data: FormData, verb: string) {
    const path = 'sponsorship/upload';
    return this.http
      .put(
        `${environment.api_url}${path}${verb}`,
        data,
        ({
          headers: new HttpHeaders({
            Authorization: `Token ${this.jwtService.getToken()}`
          })
        })
      )
      .map(res => res || []);
  }
}
